﻿{
  "registration": {
    "sectionTitle": "APSAUGOS POSTAS",
    "title": "Registracija",
    "firstName": "Vardas",
    "lastName": "Pavardė",
    "company": "Transporto įmonė",
    "companyPlaceholder": "Įveskite 3 raides paieškai...",
    "plate": "Valstybinis numeris",
    "orderNumber": "Užsakymo numeris",
    "photo": "Vairuotojo nuotrauka",
    "takePhoto": "Fotografuoti",
    "chooseFile": "Pasirinkti failą",
    "security": "Perskaičiau ir sutinku su aikštelės saugos protokolu",
    "securitySub": "Reikalingos AAP · Draudžiamos zonos · Maks. greitis 10 km/h",
    "submit": "Patvirtinti registraciją",
    "success": "Registracija sėkmingai baigta",
    "qrInstruction": "Nuskaitykite šį QR kodą, kad pasiektumėte aikštelės žemėlapį ir paslaugas iš savo telefono ar planšetės.",
    "qrDone": "Registracija baigta",
    "nextRegistration": "Kita registracija",
    "errorRequired": "Šis laukas yra privalomas",
    "errorSecurity": "Turite priimti saugos protokolą",
    "phone": "Telefono numeris",
    "phonePlaceholder": "+370 612 34567",
    "tankCapacity": "Cisternos talpa (litrai)",
    "tankCapacityPlaceholder": "Pvz. 26000",
    "baffles": "Pertvaros",
    "bafflesYes": "Taip",
    "bafflesNo": "Ne",
    "tare": "Transporto priemonės tara (kg)",
    "tarePlaceholder": "Pvz. 14500",
    "washCertificate": "Plovimo sertifikatas",
    "washWashed": "Išplauta",
    "washNotWashed": "Neišplauta",
    "adr": "ADR atitiktis",
    "adrCompliant": "Atitinka",
    "adrNotCompliant": "Neatitinka",
    "groupContact": "Kontaktas",
    "groupVehicle": "Transportas ir Cisterna",
    "groupCompliance": "Atitiktis",
    "groupSecurity": "Sauga",
    "securityProtocol": "Objekto saugos protokolas",
    "groupMedia": "Medija",
    "fieldOptional": "Neprivalomas",
    "fieldRequired": "Privalomas",
    "wizardStepLabel": "Žingsnis",
    "wizardStep1Title": "Kokią operaciją atliekate?",
    "wizardStep1Subtitle": "Pasirinkite intervencijos tipą objekte",
    "wizardExpedition": "Išsiuntimas",
    "wizardLivraison": "Pristatymas",
    "wizardStep2Title": "Užsakymo numeris",
    "wizardOrderLabel": "Užsakymo numeris",
    "wizardOrderHintExpedition": "Pavyzdys: AR… arba 5…",
    "wizardOrderHintLivraison": "Pavyzdys: 85…",
    "wizardOrderError": "Netinkamas formatas šiam operacijos tipui",
    "wizardOrderUnknown": "Neturiu / nežinau užsakymo numerio",
    "wizardOrderPlanned": "Rastas planuotas užsakymas — laukai užpildyti",
    "wizardValidate": "Patvirtinti",
    "wizardBack": "Atgal",
    "wizardStep3Title": "Kokio tipo transporto priemonę vairuojate?",
    "wizardStep3Subtitle": "Pasirinkite savo transporto priemonę",
    "wizardTank": "Cisterna",
    "wizardTrailer": "Priekaba",
    "wizardModalIso": "ISO cisterna?",
    "wizardModalContainer": "Konteineris?",
    "wizardYes": "TAIP",
    "wizardNo": "NE",
    "chassisPlate": "ISO numeris",
    "containerPlate": "Konteinerio numeris",
    "tareIso": "ISO tara (kg)",
    "tareContainer": "Konteinerio tara (kg)",
    "pinTitle": "PIN kodas",
    "pinError": "Neteisingas kodas",
    "pinCancel": "Atšaukti",
    "capturePhoto": "Fotografuoti",
    "guardAccess": "Apsaugos prieiga",
    "trailerPlate": "Priekabos numeris"
  },
  "driver": {
    "title": "Sveiki atvykę į objektą",
    "subtitle": "Vykdykite apsaugos posto nurodymus",
    "yourPosition": "Jūsų vieta",
    "enableGps": "Įjungti buvimo vietą",
    "gpsActive": "Buvimo vieta aktyvi",
    "gpsError": "Buvimo vieta neprieinama",
    "gpsPermission": "Leiskite prieigą prie vietos",
    "helpBtn": "Man reikia pagalbos",
    "helpSent": "Pagalbos prašymas išsiųstas",
    "helpAlready": "Jūsų prašymas gautas",
    "sessionExpired": "Sesija baigta",
    "sessionExpiredMsg": "Jūsų sesija baigėsi. Ačiū už apsilankymą.",
    "waitingMsg": "Prašome palaukti, darbuotojas netrukus jums padės",
    "estimatedPassage": "Numatomas pravažiavimo laikas",
    "instruction": "Instrukcija",
    "instructionClose": "Uždaryti"
  },
  "incident": {
    "alertTitle": "PAVOJUS — NEDELSIANT EVAKUOKITĖS",
    "alertSubtitle": "Nedelsiant vadovaukitės žemėlapio nurodymais",
    "alertInstruction": "Eikite į artimiausią susirinkimo vietą",
    "safeNow": "Aš esu saugus",
    "normalMode": "Situacija grįžo į normalią",
    "evacuation": "Evakuacijos taškas",
    "assembly": "Susirinkimo vieta",
    "firstAid": "Pirmoji pagalba"
  },
  "messages": {
    "title": "Operatoriaus žinutė",
    "placeholder": "Rašykite žinutę vairuotojui...",
    "send": "Siųsti",
    "dictate": "Diktuoti",
    "translatedTo": "Išversta į",
    "noMessages": "Žinučių nėra",
    "reactionSent": "Reakcija išsiųsta"
  }
}
